import * as React from 'react';
import * as S from './styles';
import { OperationHour } from 'features/Dealers/Listings/OperationHours/state/types';
import { parseHoursTo12Format, parseStringDateToDate } from 'features/Dealers/Listings/Data/state/utils';

export interface ViewOperationHoursProps {
  operationHoursState: OperationHour[];
}

const DaysOfWeek = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']

const ViewOperationHours: React.FC<ViewOperationHoursProps> = (props) => {
  const [operationHours, setOperationHours] = React.useState<OperationHour[]>([])

  const formatOperationHours = ()=>{
  
    let newOperationHours : OperationHour[]=[]
    DaysOfWeek.map((day,index)=>{

      let item = props.operationHoursState?.find(f=> f.openDay?.toLocaleLowerCase() == day.toLocaleLowerCase())
      let operationHour: OperationHour= {
        openDay: day,
        openTime: item && item.openTime!= "Closed" && item.openTime!= undefined ? item.openTime: "",
        closeDay:day,
        closeTime:item && item.closeTime!= "Closed" && item.closeTime!= undefined? item.closeTime: "",
      }
      newOperationHours.push(operationHour)
    })

    setOperationHours(newOperationHours)

  }
  React.useEffect(()=>{
    if (props.operationHoursState)    
    formatOperationHours()
  },[props.operationHoursState])


  return (
    <S.ViewSpecialHourContainer>
      <S.ViewSpecialHourSection>
        <S.ViewSpecialHourList>
          {
            operationHours.map((operationHour, index) => {
              return (
                <S.ViewSpecialHourLabel key={index}>
                  <S.ViewSpecialHourLabelDescription>
                    {operationHour.openDay}
                  </S.ViewSpecialHourLabelDescription>
                  <S.ViewSpecialHourLabelStatus>
                    {               
                      (operationHour.openTime!="" && operationHour.openTime!=undefined)?parseHoursTo12Format(operationHour.openTime, operationHour.closeTime):`Closed`                      
                    }
                  </S.ViewSpecialHourLabelStatus>
                </S.ViewSpecialHourLabel>
              )
            })
          }
        </S.ViewSpecialHourList>
      </S.ViewSpecialHourSection>
    </S.ViewSpecialHourContainer>
  )
}

export default ViewOperationHours